// Documento que tiene funciones utiles del proyecto
import $ from "jquery";
import imageCompression from "browser-image-compression";

// Funcion que devuelve la fecha actual
export function calculateDate() {
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!
  let yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }

  today = yyyy + "-" + mm + "-" + dd; //Fecha actual para el max date

  return today;
}

export const dateToString = (date) => {
  const d = new Date(date);
  return date ? `${d.getDate() < 10 ? `0${d.getDate() }` : `${d.getDate() }`}-${(d.getMonth() + 1) < 10 ? `0${(d.getMonth() + 1)}` : `${(d.getMonth() + 1)}`}-${d.getFullYear()}` : null;
};

export const dateToStringEN = (date) => {
  const d = new Date(date);
  return date ? `${d.getFullYear()}-${(d.getMonth() + 1) < 10 ? `0${(d.getMonth() + 1)}` : `${(d.getMonth() + 1)}`}-${d.getDate() < 10 ? `0${d.getDate() }` : `${d.getDate() }`}` : null;
};

// Funcion que cambia el formate de la fecha

export function changeFormatDate(date) {
  let dd = date.getDate();
  let mm = date.getMonth() + 1; //January is 0!
  let yyyy = date.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }

  date = yyyy + "-" + mm + "-" + dd; //Fecha actual para el max date

  return date;
}

// Funcion que le pasamos por parámetro los campos que necesitamos para hacer la llamada a la API
export async function callAjaxGet(metodo, url, ErrorHandling) {
  // console.log(metodo);
  // console.log(url);
  let response = null;
  let settings = {
    url: url,
    method: metodo,
    xhrFields: {
      withCredentials: true,
    },
    timeout: 0,
    form: null,
  };
  response = await $.ajax(settings).fail(function (response) {
    ErrorHandling(response);
  });
  return response;
}

// Funcion que devuelve un array con todos los elementos a false en funcion del tamaño de otro array
export function falseArray(array) {
  let response_array = [];
  for (let i = 0; i < array.length; i++) {
    response_array.push(false);
  }
  return response_array;
}

// Función que comprueba que la photo tenga un peso menor de 512000 kb
export function validPhoto(photoSize) {
  return photoSize < 512000;
}

// Función que comprueba que el pdf sea menor de 2MB
export function validPdf(PdfSize) {
  return PdfSize < 2097152;
}

// Función para formatear las fechas
export function formatDate(input) {
  let fecha_final = "";
  if (input !== undefined && input !== "" && input !== null) {
    let datePart = input.match(/\d+/g),
      year = datePart[0], // .substring(2), // get only two digits
      month = datePart[1],
      day = datePart[2];
    fecha_final = day + "/" + month + "/" + year;
  }
  return fecha_final;
}

// En un formulario, elimina los datos que no se han puesto valor
export const removeEmptyFields = (data) => {
  Object.keys(data).forEach((key) => {
    if (data[key] === "" || data[key] === null) {
      delete data[key];
    }
  });
};

// Recibe por parámetro un objeto lo recorre lo añade a un form data y lo devuelve
export const objectToFormData = (data, removeEmpty = false) => {
  if (removeEmpty) {
    removeEmptyFields(data);
  }

  let bodyData = new FormData();
  for (const property in data) {
    // Si es un array (normalmente files) metemos sus datos uno a uno
    if (Array.isArray(data[property]) || Object.prototype.toString.call(data[property]) === "[object FileList]") {
      for (const e of data[property]) {
        bodyData.append(property, e);
      }
    } else {
      bodyData.append(property, data[property]);
    }
  }
  return bodyData;
};

// Recibe una fecha tipo Date y la pasa a formato string para los formularios (defaultValues)
export const dateToString2 = (date) => {
  if (date instanceof Date && !isNaN(date.valueOf())) return date.toISOString().split("T")[0];
};

// Recibe por parámetro una foto y un evento pone el onError de la foto a null
// y establece la foto por defecto
export const handleOnImg404 = (e, defaultImg) => {
  e.target.onerror = null;
  e.target.src = defaultImg;
};

// Función para calcular los años pasados desde una fecha
export const calculateAge = (birthday) => {
  // birthday is a date
  let ageDifMs = Date.now() - new Date(birthday);
  let ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

// Función para sumar años a una fecha
export const addYears = (date, years = 1) => {
  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();
  return new Date(year + years, month, day);
};

// Comprime las imagenes que se le pasan en un array
// Devuelve un array con las imagenes comprimidas a un maximo de 500MB o false si hay un error
export const compressImages = async (files) => {
  let compressedFiles = [];
  for (let i = 0; i < files.length; i++) {
    try {
      let mf = new File(
        [
          await imageCompression(files[i], {
            maxSizeMB: 0.4,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
          }),
        ],
        files[i].name,
        { type: files[i].type, lastModified: new Date().getTime() }
      );

      compressedFiles.push(mf);
    } catch (error) {
      return false;
    }
  }

  return compressedFiles;
};

// Función para abrir el documento en una nueva pestaña en el navegador
export const downloadFile = async (route) => {
  let settings = {
    url: route,
    method: "GET",
    xhrFields: {
      withCredentials: true,
    },
  };
  return $.ajax(settings)
    .done(() => {
      window.open(`${process.env.REACT_APP_API_URL}${route}`, "_blank");
      return true;
    })
    .fail(() => {
      return false;
    });
};
